import React, { useState, useRef, useEffect } from "react";
import "./Home.css";

import Arrow from "../Assets/arrow.svg";
import Blue from "../Assets/Blue-color.svg";
import Red from "../Assets/red-color.svg";
import Green from "../Assets/green-color.svg";
import Grey from "../Assets/grey-color.svg";

const COLOR_MAP = {
  Grey: [0.15, 0.22, 0.3, 1],
  Red: [1, 0, 0, 1],
  Blue: [0, 0.18, 1, 1],
  Green: [0, 0.6, 0.1, 1],
};

const Home = () => {
  const [open, setOpen] = useState(false);
  const [activeAnim, setActiveAnim] = useState("Static");
  const [selectedColor, setSelectedColor] = useState("Grey");

  const modelRef = useRef(null);

  useEffect(() => {
    const car = modelRef.current;
    if (!car) return;

    const onLoad = () => {
      const mat = car.model?.materials?.find(
        (m) => m.name === "Body Material"
      );

      if (mat) {
        mat.pbrMetallicRoughness.setBaseColorFactor(
          COLOR_MAP[selectedColor]
        );
      }

      console.log(car.availableAnimations);
    };

    car.addEventListener("load", onLoad);
    return () => car.removeEventListener("load", onLoad);
  }, [selectedColor]);

  const handleColorChange = (colorName) => {
    setSelectedColor(colorName);

    const car = modelRef.current;
    if (!car?.model) return;

    const mat = car.model.materials.find(
      (m) => m.name === "Body Material"
    );

    if (mat) {
      mat.pbrMetallicRoughness.setBaseColorFactor(
        COLOR_MAP[colorName]
      );
    }
  };

  const stopAnimation = () => {
    const car = modelRef.current;
    if (!car) return;

    car.pause();
    car.currentTime = 0;
    car.animationName = "";
  };

  const playSequential = async (car, animations) => {
    for (const anim of animations) {
      car.animationName = anim;
      car.currentTime = 0;
      await new Promise((r) => {
        car.play();
        setTimeout(() => r(), 1200);
      });
    }
  };

  const handleAnimChange = (animKey) => {
    const car = modelRef.current;
    if (!car) return;

    stopAnimation();
    setActiveAnim(animKey);

    const animations = car.availableAnimations || [];

    if (animKey === "Static") return;

    if (animKey === "Doors") {
      const fanAnim =
        animations.find((a) =>
          a.toLowerCase().includes("fan")
        ) ||
        animations.find((a) =>
          a.toLowerCase().includes("rotate")
        );

      if (!fanAnim) return;

      car.animationName = fanAnim;
      requestAnimationFrame(() => car.play());
      return;
    }

    if (animKey === "Wheels") {
      const steeringAnim = animations.find((a) =>
        a.toLowerCase().includes("stairing")
      ) || "stairing wheelAction";

      car.animationName = steeringAnim;
      requestAnimationFrame(() => car.play());
      return;
    }

    if (animKey === "Windows") {
      const wheelSequence = [
        "Wheel 2.001Action",
        "Wheel 2.002Action",
        "Wheel 2.003Action",
        "4Action",
      ];

      playSequential(car, wheelSequence);
      return;
    }
  };

  return (
    <main>
      <div className="background"></div>

      <div className="content">
        <model-viewer
          ref={modelRef}
          src="/3d final.glb"
          alt="3D Model"
          auto-rotate
          camera-controls
          disable-zoom
        />
      </div>

      <div className="sidebar-wrap">
        <div className="sidebar-tab" onClick={() => setOpen(!open)}>
          <img
            className={`arrow-icon ${open ? "flipped" : ""}`}
            src={Arrow}
            alt=""
          />
        </div>

        <div className={`sidebar ${open ? "open" : ""}`}>
          <div className="sidebar_div">
            <h1>Configurator Options</h1>

            <div className="sidebar_div1">
              <h2>Colors</h2>

              <div className="color_div">
                <img
                  className={`color_svg ${
                    selectedColor === "Grey" ? "selected" : ""
                  }`}
                  src={Grey}
                  onClick={() => handleColorChange("Grey")}
                />
                <img
                  className={`color_svg ${
                    selectedColor === "Red" ? "selected" : ""
                  }`}
                  src={Red}
                  onClick={() => handleColorChange("Red")}
                />
                <img
                  className={`color_svg ${
                    selectedColor === "Blue" ? "selected" : ""
                  }`}
                  src={Blue}
                  onClick={() => handleColorChange("Blue")}
                />
                <img
                  className={`color_svg ${
                    selectedColor === "Green" ? "selected" : ""
                  }`}
                  src={Green}
                  onClick={() => handleColorChange("Green")}
                />
              </div>
            </div>

            <div className="sidebar_div1">
              <h2>Animation</h2>

              <div className="sidebar_div2">
                <button
                  className={`animation_button ${
                    activeAnim === "Static" ? "active" : ""
                  }`}
                  onClick={() => handleAnimChange("Static")}
                >
                  <span className="button_text">Static</span>
                </button>

                <button
                  className={`animation_button ${
                    activeAnim === "Doors" ? "active" : ""
                  }`}
                  onClick={() => handleAnimChange("Doors")}
                >
                  <span className="button_text">Fan</span>
                </button>
              </div>

              <div className="sidebar_div2">
                <button
                  className={`animation_button ${
                    activeAnim === "Wheels" ? "active" : ""
                  }`}
                  onClick={() => handleAnimChange("Wheels")}
                >
                  <span className="button_text">
                    Steering Wheel
                  </span>
                </button>

                <button
                  className={`animation_button ${
                    activeAnim === "Windows" ? "active" : ""
                  }`}
                  onClick={() => handleAnimChange("Windows")}
                >
                  <span className="button_text">
                    Wheel
                  </span>
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </main>
  );
};

export default Home;